import { post } from '../axios'

export const detection = params => post('/h5/esign/v1/detection', params)
